import React from 'react';
import { List, ListItem, ListItemText } from '@material-ui/core';
import useStyles from './styles';

const LinkList = ({ Links }) => {
    const classes = useStyles();
    return (
        <List
            component="nav"
            aria-labelledby="nested-list-subheader"
        >
            {
                Links.map((el, index) => (
                    <ListItem button  key={index} className={classes.button}>
                        <ListItemText primary={el} />
                    </ListItem>
                ))
            }
        </List>
    )
}

export default LinkList
